import { render, staticRenderFns } from "./JobApplicants.vue?vue&type=template&id=2160815f&scoped=true&"
import script from "./JobApplicants.vue?vue&type=script&lang=ts&"
export * from "./JobApplicants.vue?vue&type=script&lang=ts&"
import style0 from "./JobApplicants.vue?vue&type=style&index=0&id=2160815f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2160815f",
  null
  
)

export default component.exports